module.exports = __webpack_public_path__ + "assets/img/thumb-McGrath-Social-Ad-Video.cac57924.webp";